export const CONTENT_SUB_PAGE = 'content-sub-page';
